import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { NgClass } from '@angular/common';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';
import { CartExportComponent } from '../../../import-export/components/cart-export/cart-export.component';
import { CartImportActionComponent } from '../../../import-export/components/cart-import-action/cart-import-action.component';
import { CartImportMicrocatActionComponent } from '../../../import-export/components/cart-import-microcat-action/cart-import-microcat-action.component';
import { CartDeleteComponent } from '../cart-delete/cart-delete.component';
import { CartCalculateModeComponent } from '../cart-calculate-mode/cart-calculate-mode.component';
import { TranslatePipe } from '@spartacus/core';


@Component({
    selector: 'app-cart-actions',
    templateUrl: './cart-actions.component.html',
    imports: [NgClass, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, CartExportComponent, CartImportActionComponent, CartImportMicrocatActionComponent, CartDeleteComponent, CartCalculateModeComponent, TranslatePipe]
})
export class CartActionsComponent implements OnInit, OnDestroy {
  public hasEntries = false;
  public internal = true;
  public skipAutomaticCalculation = false;

  private subscription: Subscription = new Subscription();

  constructor(private activeCartService: ActiveCartFacade) {
  }

  ngOnInit(): void {
    this.subscription.add(this.activeCartService.getEntries().pipe(map(entries => entries.length > 0)).subscribe(b => this.hasEntries = b));
    this.subscription.add(this.activeCartService.getActive().pipe(map(cart => cart.fromConfigurator === true)).subscribe(b => this.internal = !b));
    this.subscription.add(this.activeCartService.getActive().pipe(map(cart => cart.skipAutomaticCalculation === true)).subscribe(b => this.skipAutomaticCalculation = b));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getStyle(): string {
    return this.hasEntries ? '' : 'cart-actions__margin-bottom';
  }
}
